import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const messages = {
  fr: {
    appName: "Lexihab",
    tagline: "Le droit de l'habitat, accessible à tous",
    subTagline:
      "Assistant juridique bilingue pour l'urbanisme et l'habitat au Cameroun. Posez vos questions, recevez des réponses sourcées.",
    nav: {
      home: "Accueil",
      chat: "Assistant",
      pricing: "Tarifs",
      admin: "Espace admin",
      login: "Connexion",
      logout: "Déconnexion",
      subscriberLogin: "Espace abonné",
    },
    hero: {
      ctaChat: "Poser une question",
      ctaAdmin: "Accès administrateur",
      stat1: "Textes référencés",
      stat2: "Articles indexés",
      stat3: "Disponibilité",
    },
    pillars: {
      title: "Un outil au service du droit camerounais",
      p1Title: "Corpus officiel",
      p1Desc:
        "Lois, décrets, arrêtés et circulaires régissant l'urbanisme et l'habitat, indexés et interrogeables en langage naturel.",
      p2Title: "Réponses sourcées",
      p2Desc:
        "Chaque affirmation est accompagnée de sa référence juridique exacte (décret, article, page).",
      p3Title: "Bilingue FR / EN",
      p3Desc:
        "Interrogez le corpus en français ou en anglais ; les sources officielles restent fidèles.",
    },
    chat: {
      title: "Assistant Lexihab",
      subtitle: "Posez une question sur le droit de l'urbanisme au Cameroun",
      placeholder: "Ex. Comment obtenir un permis de construire ?",
      send: "Envoyer",
      loading: "Recherche dans le corpus juridique…",
      suggestions: "Questions fréquentes",
      sources: "Sources",
      page: "p.",
      disclaimer:
        "Ces informations sont fournies à titre indicatif. Consultez un juriste qualifié pour toute décision officielle.",
      welcome:
        "Bonjour. Je suis Lexihab, votre assistant juridique spécialisé en urbanisme et habitat au Cameroun. Sélectionnez une question suggérée ou posez la vôtre.",
      floatingButton: "Poser une question",
      floatingTooltip: "Notre assistant juridique est disponible",
      suggItems: [
        "Comment obtenir un permis de construire ?",
        "Quelles sont les règles de lotissement ?",
        "Quels sont mes droits en cas d'expropriation ?",
        "Comment immatriculer un terrain au Cameroun ?",
      ],
    },
    admin: {
      loginTitle: "Espace administrateur",
      loginSubtitle: "Accès réservé à l'équipe administrative de la plateforme Lexihab",
      email: "Adresse courriel",
      password: "Mot de passe",
      signIn: "Se connecter",
      dashboard: "Tableau de bord",
      overview: "Vue d'ensemble",
      documents: "Corpus juridique",
      upload: "Importer un texte",
      search: "Recherche avancée",
      stats: "Statistiques",
      feedback: "Retours citoyens",
      welcomeBack: "Bienvenue",
      statsDocs: "Textes juridiques",
      statsChunks: "Articles indexés",
      statsQueries: "Requêtes totales",
      statsAvgTime: "Temps moyen (ms)",
      statsPublic: "Requêtes citoyens",
      statsAdmin: "Requêtes agents",
      statsUptime: "Disponibilité",
      recentLogs: "Dernières interrogations",
      noLogs: "Aucune interrogation récente.",
    },
    documents: {
      title: "Corpus juridique",
      subtitle: "Gérez les textes indexés : statut, archivage, suppression.",
      filterAll: "Tous",
      filterType: "Type de document",
      filterStatus: "Statut",
      pages: "pages",
      articles: "articles",
      quality: "Qualité OCR",
      actions: "Actions",
      markAbroge: "Marquer abrogé",
      markEnVigueur: "Remettre en vigueur",
      markModifie: "Marquer modifié",
      delete: "Supprimer",
      view: "Consulter",
      confirmDelete: "Confirmer la suppression définitive ?",
      empty: "Aucun document pour ces filtres.",
    },
    uploadP: {
      title: "Importer un nouveau texte",
      subtitle:
        "Glissez un PDF scanné ou saisissez le texte directement. Le système effectue l'OCR, le découpage juridique et l'indexation vectorielle.",
      tabPdf: "Depuis PDF (OCR)",
      tabText: "Texte brut",
      dropHere: "Glissez-déposez votre PDF ici",
      orClick: "ou cliquez pour parcourir",
      selected: "Fichier sélectionné",
      metadata: "Métadonnées",
      fTitle: "Titre du texte",
      fType: "Type de document",
      fReference: "Référence officielle",
      fDatePub: "Date de publication",
      fDateEntry: "Date d'entrée en vigueur",
      fStatus: "Statut",
      rawText: "Collez ici le texte brut du document juridique",
      submit: "Lancer l'ingestion",
      processing: "Ingestion en cours…",
      successTitle: "Ingestion réussie",
      errorTitle: "Erreur d'ingestion",
    },
    searchP: {
      title: "Recherche avancée",
      subtitle: "Recherche sémantique dans le corpus avec filtres.",
      query: "Requête",
      placeholder: "Ex. délai d'instruction permis de construire",
      submit: "Rechercher",
      results: "résultat(s)",
      noResults: "Aucun résultat.",
      similarity: "Pertinence",
    },
    types: {
      loi: "Loi",
      decret: "Décret",
      arrete: "Arrêté",
      circulaire: "Circulaire",
      ordonnance: "Ordonnance",
    },
    status: {
      en_vigueur: "En vigueur",
      abroge: "Abrogé",
      modifie: "Modifié",
    },
    common: {
      loading: "Chargement…",
      save: "Enregistrer",
      cancel: "Annuler",
      all: "Tous",
      back: "Retour",
      readMore: "En savoir plus",
      builtBy: "Hitech Solutions — Yaoundé, Cameroun",
    },
  },
  en: {
    appName: "Lexihab",
    tagline: "Housing law, accessible to all",
    subTagline:
      "Bilingual legal assistant for Cameroonian urban planning and housing. Ask questions, get sourced answers.",
    nav: {
      home: "Home",
      chat: "Assistant",
      pricing: "Pricing",
      admin: "Admin",
      login: "Sign in",
      logout: "Sign out",
      subscriberLogin: "Subscriber area",
    },
    hero: {
      ctaChat: "Ask a question",
      ctaAdmin: "Admin access",
      stat1: "Legal texts",
      stat2: "Indexed articles",
      stat3: "Availability",
    },
    pillars: {
      title: "A tool serving Cameroonian law",
      p1Title: "Official corpus",
      p1Desc:
        "Laws, decrees, orders and circulars governing urban planning and housing — indexed and searchable in natural language.",
      p2Title: "Sourced answers",
      p2Desc:
        "Every statement comes with its exact legal reference (decree, article, page).",
      p3Title: "Bilingual FR / EN",
      p3Desc:
        "Query the corpus in French or English; official sources remain faithful.",
    },
    chat: {
      title: "Lexihab Assistant",
      subtitle: "Ask a question about Cameroonian urban planning law",
      placeholder: "E.g. How do I get a building permit?",
      send: "Send",
      loading: "Searching the legal corpus…",
      suggestions: "Frequently asked questions",
      sources: "Sources",
      page: "p.",
      disclaimer:
        "This information is provided for guidance only. Consult a qualified lawyer for any official decision.",
      welcome:
        "Hello. I'm Lexihab, your legal assistant specialized in Cameroonian urban planning and housing. Pick a suggested question or ask your own.",
      floatingButton: "Ask a question",
      floatingTooltip: "Our legal assistant is available",
      suggItems: [
        "How do I get a building permit?",
        "What are the subdivision rules?",
        "What are my rights in case of expropriation?",
        "How to register a land title in Cameroon?",
      ],
    },
    admin: {
      loginTitle: "Admin Portal",
      loginSubtitle: "Reserved for the Lexihab platform administrative team",
      email: "Email address",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Dashboard",
      overview: "Overview",
      documents: "Legal corpus",
      upload: "Import a text",
      search: "Advanced search",
      stats: "Statistics",
      feedback: "Citizen feedback",
      welcomeBack: "Welcome",
      statsDocs: "Legal texts",
      statsChunks: "Indexed articles",
      statsQueries: "Total queries",
      statsAvgTime: "Avg time (ms)",
      statsPublic: "Citizen queries",
      statsAdmin: "Agent queries",
      statsUptime: "Uptime",
      recentLogs: "Recent queries",
      noLogs: "No recent queries.",
    },
    documents: {
      title: "Legal corpus",
      subtitle: "Manage indexed texts: status, archive, delete.",
      filterAll: "All",
      filterType: "Document type",
      filterStatus: "Status",
      pages: "pages",
      articles: "articles",
      quality: "OCR quality",
      actions: "Actions",
      markAbroge: "Mark repealed",
      markEnVigueur: "Reinstate",
      markModifie: "Mark modified",
      delete: "Delete",
      view: "View",
      confirmDelete: "Confirm permanent deletion?",
      empty: "No document for these filters.",
    },
    uploadP: {
      title: "Import a new text",
      subtitle:
        "Drop a scanned PDF or paste raw text. The system runs OCR, legal chunking and vector indexing.",
      tabPdf: "From PDF (OCR)",
      tabText: "Raw text",
      dropHere: "Drag & drop your PDF here",
      orClick: "or click to browse",
      selected: "Selected file",
      metadata: "Metadata",
      fTitle: "Text title",
      fType: "Document type",
      fReference: "Official reference",
      fDatePub: "Publication date",
      fDateEntry: "Entry-into-force date",
      fStatus: "Status",
      rawText: "Paste the raw legal text here",
      submit: "Start ingestion",
      processing: "Ingesting…",
      successTitle: "Ingestion successful",
      errorTitle: "Ingestion error",
    },
    searchP: {
      title: "Advanced search",
      subtitle: "Semantic search across the corpus with filters.",
      query: "Query",
      placeholder: "E.g. building permit processing time",
      submit: "Search",
      results: "result(s)",
      noResults: "No results.",
      similarity: "Relevance",
    },
    types: {
      loi: "Law",
      decret: "Decree",
      arrete: "Order",
      circulaire: "Circular",
      ordonnance: "Ordinance",
    },
    status: {
      en_vigueur: "In force",
      abroge: "Repealed",
      modifie: "Modified",
    },
    common: {
      loading: "Loading…",
      save: "Save",
      cancel: "Cancel",
      all: "All",
      back: "Back",
      readMore: "Learn more",
      builtBy: "Hitech Solutions — Yaoundé, Cameroon",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem("lexhab_locale") || "fr");

  useEffect(() => {
    localStorage.setItem("lexhab_locale", locale);
    document.documentElement.setAttribute("lang", locale);
  }, [locale]);

  const t = useCallback(
    (path, fallback) => {
      const parts = path.split(".");
      let cur = messages[locale];
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return fallback ?? path;
      }
      return cur;
    },
    [locale]
  );

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
